/* src/app/components/paciente/paciente-menu/paciente-menu.component.scss */
.navbar-collapse {
  background: #fff;
  padding: 20px;
}
@media screen and (min-width: 768px) {
  .navbar-collapse {
    background: transparent;
    padding: 0;
  }
}
/*# sourceMappingURL=paciente-menu.component.css.map */
